export default {
  strict: true,
  namespaced: true,
  state: {
    profile: {
      loading: false,
      info: {
        id: '',
        consId: '',
        logo: '',
        username: '',
        password: '',
        name: '',
        email: '',
        color: '',
        mobile: '',
        website: '',
        cardOwner: '',
        creditCard: '',
        cardExpiration: '',
        cardCVV: '',
        billingAddress1: '',
        billingAddress2: '',
        billingCity: '',
        billingState: '',
        billingZip: '',
        biilingCountry: 'US',
        stripeUrl: '',
        active: true,
        discountCode: ''
      },
      rsvp: {
        list: [],
        maxList: 0,
        currentPage: 1,
        perPage: 100,
        order: 'created',
        orderAsc: 1,
        loading: false,
        dateFrom: '',
        dateTo: ''
      }
    }
  },
  mutations: {
    setNationalNumber (state, value) { state.profile.info.mobile = value},
    setProfileLoading (state, value) { state.profile.loading = value},
    resetProfileInfo (state) {
      state.profile.info = {
        id: '',
        consId: '',
        logo: '',
        username: '',
        password: '',
        name: '',
        email: '',
        color: '',
        mobile: '',
        website: '',
        cardOwner: '',
        creditCard: '',
        cardExpiration: '',
        cardCVV: '',
        billingAddress1: '',
        billingAddress2: '',
        billingCity: '',
        billingState: '',
        billingZip: '',
        biilingCountry: 'US',
        stripeUrl: '',
        active: true
      }
    },
    setProfile (state, value) { state.profile.info = value },
    setProfileColor (state, value) { state.profile.info.color = value },
    setProfileCreditInfo (state, data) {
      state.profile.info.cardOwner = data.cardOwner
      state.profile.info.creditCard = data.creditCard
      state.profile.info.cardExpiration = data.cardExpiration
    },

    resetRsvpList (state) { state.profile.rsvp.list = [] },
    addRsvp (state, value) { state.profile.rsvp.list = value },
    setRsvpMaxList (state, value) { state.profile.rsvp.maxList = value },
    setRsvpCurrentPage (state, value) { state.profile.rsvp.currentPage = value },
    setRsvpPerPage (state, value) { state.profile.rsvp.perPage = value },
    setRsvpOrder (state, value) { state.profile.rsvp.order = value },
    setRsvpOrderAsc (state, value) { state.profile.rsvp.orderAsc = value },
    setRsvpLoading (state, value) { state.profile.rsvp.loading = value },
    setRsvpDate (state, data) { state.profile.rsvp[data.field] = data.value }
  },
  sharedMutations: []
}



// WEBPACK FOOTER //
// ./src/store/corporate/profile.js